// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { render, createElement, LocaleProvider } from '@plesk/ui-library';
import ViewSwitcher from './ViewSwitcher';

module.exports = (container, { locale, ...props }) => {
    render((
        <LocaleProvider messages={locale}>
            <ViewSwitcher {...props} />
        </LocaleProvider>
    ), container);
};



// WEBPACK FOOTER //
// ./app/view-switcher/index.js